import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "underline",
  "use": "underline-usage",
  "viewBox": "0 0 448 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 448 512\" id=\"underline\"><path fill=\"currentColor\" d=\"M32 48h32v208c0 88.22 71.78 160 160 160s160-71.78 160-160V48h32a16 16 0 0016-16V16a16 16 0 00-16-16H288a16 16 0 00-16 16v16a16 16 0 0016 16h32v208a96 96 0 01-192 0V48h32a16 16 0 0016-16V16a16 16 0 00-16-16H32a16 16 0 00-16 16v16a16 16 0 0016 16zm400 416H16a16 16 0 00-16 16v16a16 16 0 0016 16h416a16 16 0 0016-16v-16a16 16 0 00-16-16z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol